export enum Steps {
	CREATE_FIRST_STORY = 0,
	SELECT_ISSUE_TYPE = 1,
	ADD_SUMMARY = 2,
	ADD_DESCRIPTION = 3,
	SELECT_PRIORITY = 4,
	SELECT_EPIC_LINK = 5,
	MOVE_ISSUE = 6,
	PULSE_CARD = 7,
}

export enum Project {
	TeamRocket = 'team-rocket',
}
export enum IssueTypeName {
	TASK = 'task',
	STORY = 'story',
	BUG = 'bug',
}
export enum EpicName {
	FEATURES = 'features',
	ANALYTICS = 'analytics',
	PAYMENTS = 'payments',
}
export enum Assignee {
	ALVIN = 'alvin',
	JANE = 'jane',
	BLAKE = 'blake',
}
export enum Priority {
	HIGH = 'high',
	CRITICAL = 'critical',
	BLOCKER = 'blocker',
	MINOR = 'minor',
}
export const stepsLength = Object.keys(Steps).length / 2;

export const MAX_ISSUE_SUMMARY_LENGTH = 255;

export const SUCCESS_MODAL_DELAY = 1500;

export const FIRST_ISSUE_ID = 'firstInteractiveDemoIssueId';
